<section class="page">
  <div class="container">
    <div>
      <div class="page-header">
        <h2>Empreendimentos</h2>
        <div class="page-header__buttons">
          <mat-form-field appearance="fill" class="no-margin">
            <mat-label>Escolha um intervalo de datas</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input
                matStartDate
                placeholder="Data inicial"
                [(ngModel)]="dataInicial"
                name="dataInicial"
              />
              <input
                matEndDate
                placeholder="Data final"
                [(ngModel)]="dataFinal"
                name="dataFinal"
                (ngModelChange)="onDataFinalChange($event)"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <button mat-raised-button class="btn-excel" (click)="generateExcel()">
            EXPORTAR LEADS
          </button>
        </div>
      </div>
    </div>
    <div class="stats">
      <div class="stats-item">
        <h3 class="stats-item__label">
          <i class="fas fa-mouse"></i>
          <span>Clicks</span>
        </h3>
        <hr />
        <h2 class="stats-item__number">
          {{ homeStats?.clicks?.toLocaleString() }}
        </h2>
      </div>
      <div class="stats-item">
        <h3 class="stats-item__label">
          <i class="fas fa-phone-alt"></i>
          <span>Contatos</span>
        </h3>
        <hr />
        <h2 class="stats-item__number">
          {{ homeStats?.contatos?.toLocaleString() }}
        </h2>
      </div>
    </div>

    <div class="page-header">
      <div class="page-filters">
        <mat-form-field appearance="fill" class="no-margin">
          <mat-label>Tipo Empreendimento</mat-label>
          <mat-select
            name="idTipoEmpreendimento"
            [(ngModel)]="idTipoEmpreendimento"
            (ngModelChange)="onTipoEmpreendimentoChange($event)"
          >
            <mat-option>
              <ngx-mat-select-search
                [(ngModel)]="searchTiposEmpreendimento"
                name="searchTiposEmpreendimento"
                placeholderLabel="Pesquise aqui"
                noEntriesFoundLabel="Nenhum registro encontrado"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option>Selecionar</mat-option>
            <mat-option
              *ngFor="
                let t of tiposEmpreendimento
                  | filter : searchTiposEmpreendimento : 'nome';
                let i = index
              "
              [value]="t.id"
            >
              {{ t.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="no-margin">
          <mat-label>Tipo da oferta</mat-label>
          <mat-select
            name="tipoOferta"
            [(ngModel)]="tipoOferta"
            (ngModelChange)="onTipoOfertaChange($event)"
          >
            <mat-option>Selecionar</mat-option>
            <mat-option
              *ngFor="let e of empreendimentoTiposOferta"
              [value]="e.value"
              >{{ e.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="no-margin">
          <mat-label>Corretor</mat-label>
          <mat-select
            name="idUsuarioImobiliaria"
            [(ngModel)]="idUsuarioImobiliaria"
            (ngModelChange)="onUsuarioImobiliariaChange($event)"
            [disabled]="_auth.user.tipo === 'C'"
          >
            <mat-option>
              <ngx-mat-select-search
                [(ngModel)]="searchUsuariosImobiliaria"
                name="searchUsuariosImobiliaria"
                placeholderLabel="Pesquise aqui"
                noEntriesFoundLabel="Nenhum registro encontrado"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option>Selecionar</mat-option>
            <mat-option
              *ngFor="
                let u of usuariosImobiliaria
                  | filter : searchUsuariosImobiliaria : 'nome'
              "
              [value]="u.id"
            >
              {{ u.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="page-header__buttons">
        <button
          mat-raised-button
          color="primary"
          routerLink="/imobiliaria/empreendimentos/adicionar"
        >
          ADICIONAR EMPREENDIMENTO
        </button>
      </div>
    </div>

    <div class="content">
      <div
        class="immobile-list__notfound"
        *ngIf="!empreendimentos.length && !loading"
      >
        <span>Nenhum resultado encontrado!</span>
      </div>
      <div class="immobile-list" *ngIf="empreendimentos.length">
        <button
          class="immobile-item"
          mat-button
          *ngFor="let e of empreendimentos; let i = index"
          [style.background-image]="
            'url(' + global.imageUrl + e._imagemPrincipal + ')'
          "
          [routerLink]="['/imobiliaria/empreendimentos/editar', e.id]"
        >
          <div class="overlay"></div>
          <div class="immobile-item__content">
            <span class="address">
              {{ e.endereco }}, {{ e.numeroEndereco }} {{ e.complemento }}
              <br />
              {{ e.bairro }}, {{ e.cidade }} - {{ e.uf }}
            </span>
            <div class="price">
              <strong>{{ e.valor | currency : "BRL" }}&nbsp;</strong>
              <small *ngIf="e.tipoOferta === 'L'">/mensal</small>
            </div>
            <div class="info">
              <div class="info-item" *ngIf="e.tamanhoAreaConstruidaM2">
                <img
                  src="assets/icons/reduce.png"
                  alt="Área construída"
                  class="info-item__icon"
                />
                <span class="info-item__label"
                  >{{ e.tamanhoAreaConstruidaM2 }} m²</span
                >
              </div>
              <div class="info-item" *ngIf="e.numeroQuartos">
                <img
                  src="assets/icons/bed.png"
                  alt="Quartos"
                  class="info-item__icon"
                />
                <span class="info-item__label">{{ e.numeroQuartos }}</span>
              </div>
              <div class="info-item" *ngIf="e.numeroBanheiros">
                <img
                  src="assets/icons/sink.png"
                  alt="Banheiros"
                  class="info-item__icon"
                />
                <span class="info-item__label">{{ e.numeroBanheiros }}</span>
              </div>
              <div class="info-item" *ngIf="e.numeroBoxGaragem">
                <img
                  src="assets/icons/car.png"
                  alt="Vagas de garagem"
                  class="info-item__icon"
                />
                <span class="info-item__label">{{ e.numeroBoxGaragem }}</span>
              </div>
            </div>
            <div class="info info--stats">
              <div class="info-item">
                <i class="fas fa-mouse"></i>
                <span class="info-item__label">{{ e._clicks }}</span>
              </div>
              <div class="info-item">
                <i class="fas fa-phone-alt"></i>
                <span class="info-item__label">{{ e._contatos }}</span>
              </div>
            </div>
          </div>
        </button>
      </div>
      <div class="seemore">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <button
          mat-stroked-button
          (click)="loadMore()"
          *ngIf="!noMore && !loading"
        >
          Ver mais
        </button>
      </div>
    </div>
  </div>
</section>
